export enum HttpMediaType {
  ApplicationJson = 'application/json',
  ApplicationHal = 'application/hal+json',
  MultipartFormData = 'multipart/form-data',
}
